export default {
  error_occurred:
    'Se ha producido un error. Vuelve a intentarlo m\u00e1s tarde.',
  oops: '\u00a1Vaya!',
  okay: 'Aceptar',
  title_signout: '\u00bfCerrar sesi\u00f3n?',
  confirm_signout: 'Te desconectar\u00e1s de los siguientes equipos',
};
